import * as React from "react";
import {Field} from "redux-form";

import StyleProps from "../../../../../../shared/ts/interfaces/style";
import InputField from "./InputField";


interface InputProps extends StyleProps {
    id?: string;
    type?: string;
    name: string;
    label?: string;
    placeholder?: string;
    onValueUpdate?: (name: string) => void;
    autoFocus?: boolean;
    disabled?: boolean;
    size?: string;
    groupClassName?: string;
    maxLength?: number;
}


export default class Input extends React.Component<InputProps, {}> {
    public render(): JSX.Element {
        return (
            <Field
                {...this.props}
                component={InputField}
            />
        );
    }
}
